import { Component, effect, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ReportService } from '../../services/report.service';
import { SharedService } from 'src/app/common/services/shared.service';
import { GlobalContants } from 'src/app/common/constants/global.contants';

@Component({
  selector: 'app-report-grid',
  templateUrl: './report-grid.component.html',
  styleUrls: ['./report-grid.component.css']
})
export class ReportGridComponent implements OnInit, OnDestroy, OnChanges {

  @Input() reportData: any;
  routeSub$: Subscription = new Subscription();
  queryParams: any;
  filter_data!: { report: any; reportId: any; filter: any; };

  multi_story_residential:any;

  // showReportLabel = true;

  // hiddenLabel = ['transactions','house_and_villa','rental','office_rental']
  studyName: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private reportService : ReportService,
    private sharedService : SharedService,
    private router : Router
  ){
    effect(()=> this.multi_story_residential = this.reportService.multi_story_residential$$())
  }

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges): void {
    this.routeSub$ = this.activatedRoute.queryParams.subscribe((params) => {
      this.queryParams = params;
    });

    // ttm date logic based on report filter (only execute when date_range filter present in report).
    if(this.reportData?.query.component) {
      let newParams = { ...this.queryParams };
        this.reportService.reportFilter.forEach((filter: any) => {
          if (filter?.type === 'date_range') {
            this.reportService.isDateRangeFilterPresent.set(true);
            if (newParams && filter.required == true && !('transaction_date' in newParams)) {
              // code to append default ttm date in url.
              const today = new Date();
              let eDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
              const minDate = new Date(today);
              minDate.setFullYear(minDate.getFullYear() - 1);
              minDate.setDate(minDate.getDate() + 1);
              let sDate = `${minDate.getFullYear()}-${String(minDate.getMonth() + 1).padStart(2, "0")}-${String(minDate.getDate()).padStart(2, "0")}`;
              let finalDate = `${sDate}to${eDate},${false}`;
              newParams['transaction_date'] = finalDate;
            }else if(newParams && ('transaction_date' in newParams)) {
              // used to track the status of actual applied date.
              let status = newParams['transaction_date'].split(',')[1] === 'true' ? true : false;

              this.reportService.ttmToggleVariable.set(status);
              this.reportService.ttmToggleState.set(status)
            }else{
              console.log('refreash ', this.reportService.ttmToggleVariable());

              this.reportService.ttmToggleVariable.set(true);
            }
            this.queryParams = newParams;
            this.router.navigate(
              [`${this.sharedService.CityLang}/${GlobalContants.Routes.Reports}`],
              {queryParams: newParams});
          }
        });
    }
    this.studyName = this.reportService?.selectedStudies?.study_name;
  }

  ngOnDestroy(): void {
    this.routeSub$.unsubscribe();
  }
}
